/* Заголовки столбцов таблиц.
 *
 * Раньше часть заголовков была зашита по-русски прямо в описании колонок, и при
 * переключении языка таблица оставалась русской наполовину. Словарь один на все
 * экраны: одни и те же «Рев.», «Назн.», «Статус» встречаются в реестрах,
 * трансмитталах и администрировании, и переводить их порознь значит однажды
 * получить два разных перевода одного столбца.
 *
 * Ключ — русская строка: она же остаётся значением для ru, поэтому при добавлении
 * колонки словарь не обязателен — незнакомый ключ отдаётся как есть.
 */
import type { Lang } from './lang'

export const COLUMN_LABEL: Record<string, { en: string; zh: string }> = {
  'Выпуск в срок': { en: 'On time', zh: '按期签发' },
  'Дата': { en: 'Date', zh: '日期' },
  'Дата и время': { en: 'Date & time', zh: '日期和时间' },
  'Действие': { en: 'Action', zh: '操作' },
  'Дисц.': { en: 'Disc.', zh: '专业' },
  'Дисциплина': { en: 'Discipline', zh: '专业' },
  'Дисциплины': { en: 'Disciplines', zh: '专业' },
  'Док.': { en: 'Docs', zh: '文件数' },
  'Документов': { en: 'Documents', zh: '文件数' },
  'Зам.': { en: 'Cmts', zh: '意见' },
  'Замещающий': { en: 'Deputy', zh: '代理人' },
  'Исполнитель': { en: 'Assignee', zh: '执行人' },
  'Источник': { en: 'Source', zh: '来源' },
  'Активна': { en: 'Active', zh: '启用' },
  'Код': { en: 'Code', zh: '编码' },
  'Код C': { en: 'Code C', zh: 'C 类' },
  'Код D': { en: 'Code D', zh: 'D 类' },
  'Контакт': { en: 'Contact', zh: '联系人' },
  'Контрагент': { en: 'Contractor', zh: '相对方' },
  'Назн.': { en: 'Purpose', zh: '用途' },
  'Назначение': { en: 'Purpose', zh: '用途' },
  'Наименование': { en: 'Title', zh: '名称' },
  'Наименование (EN)': { en: 'Title (EN)', zh: '名称（英文）' },
  'Лист': { en: 'Sheet', zh: '图号' },
  'Объект': { en: 'Object', zh: '对象' },
  'Титул': { en: 'Project title', zh: '项目名称' },
  'От кого направлен': { en: 'Sent by', zh: '发送方' },
  'Кому направлен': { en: 'Sent to', zh: '接收方' },
  'Ожидание': { en: 'Waiting', zh: '等待' },
  'Описание': { en: 'Description', zh: '说明' },
  'Отсутствующий': { en: 'Absent', zh: '缺席人' },
  'Отсутствует с': { en: 'Away from', zh: '缺席自' },
  'По включительно': { en: 'To inclusive', zh: '至（含）' },
  'Причина': { en: 'Reason', zh: '原因' },
  'Состояние': { en: 'State', zh: '状态' },
  'Отклонение, дн.': { en: 'Drift, days', zh: '偏差（天）' },
  'Открытых CRS': { en: 'Open CRS', zh: '未关闭意见' },
  'Параллельно': { en: 'Parallel', zh: '并行' },
  'План': { en: 'Plan', zh: '计划' },
  '№ заказчика': { en: 'Company doc no', zh: '业主文件号' },
  'План IFR': { en: 'Plan IFR', zh: '计划 IFR' },
  'План IFA': { en: 'Plan IFA', zh: '计划 IFA' },
  'План AFD': { en: 'Plan AFD', zh: '计划 AFD' },
  'Подрядчик': { en: 'Contractor', zh: '承包商' },
  'Пользователь': { en: 'User', zh: '用户' },
  'Последний вход': { en: 'Last seen', zh: '最近登录' },
  'Поставщик / подрядчик': { en: 'Supplier / contractor', zh: '供应商 / 承包商' },
  'Прогноз': { en: 'Forecast', zh: '预测' },
  'Реестр': { en: 'Register', zh: '清单' },
  'Рев.': { en: 'Rev.', zh: '版次' },
  'Ревизия': { en: 'Revision', zh: '版次' },
  'Роль': { en: 'Role', zh: '角色' },
  'Содержание': { en: 'Subject', zh: '主题' },
  'Срок': { en: 'Due', zh: '期限' },
  'Статус': { en: 'Status', zh: '状态' },
  'Сторона': { en: 'Party', zh: '参与方' },
  'Строка MDR': { en: 'MDR row', zh: 'MDR 行' },
  'Тип': { en: 'Type', zh: '类型' },
  'Файл': { en: 'File', zh: '文件' },
  'Факт': { en: 'Actual', zh: '实际' },
  'Эскалация, дн': { en: 'Escalation, days', zh: '升级，天' },
  '№': { en: 'No.', zh: '序号' },
  '№ документа': { en: 'Document №', zh: '文件编号' },
  'SLA, дн': { en: 'SLA, days', zh: 'SLA，天' },
  'SLA, 1-й круг': { en: 'SLA, round 1', zh: 'SLA，第1轮' },
  'SLA, 2-й круг': { en: 'SLA, round 2', zh: 'SLA，第2轮' },
  'SLA, 3-й и далее': { en: 'SLA, round 3+', zh: 'SLA，第3轮及以后' },
  'Стадия': { en: 'Stage', zh: '阶段' },
  'Контракт': { en: 'Contract', zh: '合同' },
  'Шагов': { en: 'Steps', zh: '步骤数' },
}

/** Заголовок столбца на языке интерфейса. Незнакомый ключ отдаётся как есть. */
export const colHeader = (lang: Lang, ru: string): string => {
  if (lang === 'ru') return ru
  const label = COLUMN_LABEL[ru]
  if (!label) return ru
  return lang === 'zh' ? label.zh : label.en
}
